<script>
import options from './FormInputPhoneField.options'
export default options
</script>

<template>
  <div
    class="kb-form-input-phone-field Form__Element FormTextbox"
    :class="{ ValidationRequired: isRequired }"
  >
    <label :for="fieldName" class="Form__Element__Caption">
      {{ label }}

      <template v-if="tooltipText">
        <TooltipComponent :tooltipText="tooltipText" />
      </template>
    </label>

    <input
      class="FormTextbox__Input"
      type="phone"
      v-model="localValue"
      :autocomplete="autocomplete"
      :class="{ 'validation-error': isValidationError }"
      :id="fieldName"
      :aria-describedby="`${fieldName}__desc`"
      :placeholder="placeholder"
      :maxlength="maxlength"
      :required="isRequired ? true : false"
      @input="$emit('update:modelValue', $event.target.value)"
      @change="formLink"
      :disabled="readOnly"
    />
    <p
      class="kb-form__input-helptext"
      v-if="helpMessageLabel"
    >
      {{ helpMessageLabel }}
    </p>

    <div aria-live="assertive">
      <p class="kb-forms Form__Element__ValidationError"
        role="alert"
        v-if="inputHasValidationErrors && isValidationError">
        {{ errorMessageLabel }}
      </p>
    </div>

  </div>
</template>
